export default "__VITE_ASSET__CUvbrrz2__"